import React from 'react';

export const ZoneLocality = ({
  zoneInLocality,
  handleLocality,
}) => {
  return (
    <div className="container p-0">
      {zoneInLocality && <h1 className="h5 mb-3">Locality: </h1>}
      <div className="form-group d-flex flex-wrap align-items-stretch">
        {zoneInLocality &&
          zoneInLocality &&
          React.Children.toArray(
            zoneInLocality?.map((locality) => {
              return (
                <>
                  <div
                    className={`button-belair col-6 mb-0 mt-0 break-word`}
                    onClick={handleLocality}
                    data-locality={locality?.id}
                  >
                    {locality?.text}
                  </div>
                </>
              );
            }),
          )}
      </div>
    </div>
  );
};
